import { CommandExecutionHistoryItemsResult } from '@api';

export class AssetCommandsStateModel {
    public isCommandExecuting: { [commandName: string]: boolean };
    public commandErrors: { [commandName: string]: string };
    public commandExecutionHistorys: CommandExecutionHistoryItemsResult;
}

export const assetCommandsDefaults = {
    name: 'assetCommands',
    defaults: {
        isCommandExecuting: {},
        commandErrors: {},
        commandExecutionHistorys: {} as CommandExecutionHistoryItemsResult,
    },
};
